import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import type { PageTree } from "fumadocs-core/server";
import { source } from "@/lib/source";
import { DocsContent, docsClientLoader } from "./docs.$";

export const Route = createFileRoute("/docs")({
	component: DocsIndex,
	loader: async () => {
		const data = await loader({ data: [] });
		await docsClientLoader.preload(data.path);
		return data;
	},
});

// a wrapper because we don't want `loader` to be called on client-side
const loader = createServerFn({
	method: "GET",
})
	.inputValidator((slugs: string[]) => slugs)
	.handler(async ({ data: slugs }) => {
		const page = source.getPage(slugs);
		if (!page) throw notFound();

		return {
			tree: source.pageTree as object,
			path: page.path,
		};
	});

function DocsIndex() {
	const data = Route.useLoaderData();

	if (!data) {
		return null;
	}

	return <DocsContent path={data.path} tree={data.tree as PageTree.Folder} />;
}
